/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: Technologies
 * Page name: technologies page
 * Page Description: This is the technology page of the website of Ekathva Innovations, it consists of all the
 * details about the technologies used by the compamny.
 */

import React, { useEffect } from 'react'
import MetaTags from 'react-meta-tags'
import { Col, Container, Row } from 'react-bootstrap'
import Navbar from "components/Navbars/Navbar"
import Footer from "components/Footers/Footer"
import LandingPageTech from "components/Headers/LandingPageTech"

import 'assets/style/Style.css'

import Rpi from "assets/images/TechLogo/PNG/Rpi.png"
import Arduino from "assets/images/TechLogo/PNG/Arduino.png"
import Kicad from "assets/images/TechLogo/PNG/Kicad.png"
import Keil from "assets/images/TechLogo/PNG/Keil.png"
import Atmel from "assets/images/TechLogo/PNG/Atmel.png"
import Avr from "assets/images/TechLogo/PNG/Avr.png"
import NodeMCU from "assets/images/TechLogo/PNG/NodeMCU.png"
import Espre from "assets/images/TechLogo/PNG/Espre.png"

import Html from "assets/images/TechLogo/PNG/Html.png"
import Css from "assets/images/TechLogo/PNG/Css.png"
import Bootstrap from "assets/images/TechLogo/PNG/Bootstrap.png"
import Angular from "assets/images/TechLogo/PNG/Angular.png"
import ReactJs from "assets/images/TechLogo/PNG/React.png"
import Node from "assets/images/TechLogo/PNG/Node.png"

import Mysql from "assets/images/TechLogo/PNG/Mysql.png"
import Mongo from "assets/images/TechLogo/PNG/Mongo.png"
import Firebase from "assets/images/TechLogo/PNG/Firebase.png"
import Aws from "assets/images/TechLogo/PNG/Aws.png"
import Php from "assets/images/TechLogo/PNG/Php.png"
import Spring from "assets/images/TechLogo/PNG/Spring.png"

import Java from "assets/images/TechLogo/PNG/Java.png"
import Android from "assets/images/TechLogo/PNG/Android.png"
import Ionic from "assets/images/TechLogo/PNG/Ionic.png"
import Flutter from "assets/images/TechLogo/PNG/Flutter.png"
import Python from "assets/images/TechLogo/PNG/Python.png"
import Xcode from "assets/images/TechLogo/PNG/Xcode.png"

import Figma from "assets/images/TechLogo/PNG/Figma.png"
import Corel from "assets/images/TechLogo/PNG/Corel.png"
import Photoshop from "assets/images/TechLogo/PNG/Photoshop.png"
import Illustrator from "assets/images/TechLogo/PNG/Illustrator.png"
import Premiere from "assets/images/TechLogo/PNG/Premiere.png"


function Technologies() {

  useEffect( () => {
      window.scrollTo(0, 0)
  }, [])

    return (
    <div>
        <MetaTags>
            <title>Technologies we work with at EI | Ekathva Innovations</title>
        </MetaTags>

        <Navbar/>
        <LandingPageTech/>
        <br/>

        <h3 className='aboutus_textalign'></h3>
        <br/>
        <div className='technologies_spacing'>

            <Row>
                <Col>
                    <p className='technologies_headingfontemb aboutus_textalign' >Embedded Development</p>
                    <Container>
                        <Row className='border'>
                            <img src={Avr} alt='AVR' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Keil} alt='Keil' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Arduino} alt='Arduino ' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Python} alt='Python' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Atmel} alt='Atmel Microcontrollers' className='technologies_imgspacing' />
                        </Row>
                    </Container>
                    </Col>

                    <Col>
                      <p className='technologies_headingfontemb aboutus_textalign' >Embedded Development</p>
                    <Container>
                        <Row className='border'>
                            <img src={NodeMCU} alt='NodeMCU' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Espre} alt='ESP' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Rpi} alt='Raspberry pi' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Kicad} alt='KiCAD' className='technologies_imgspacing' />
                        </Row>
                    </Container>
                </Col>

                <Col>
                    <p className='technologies_headingfontweb aboutus_textalign' >Web</p>
                    <br />
                    <Container>
                        <Row className='border'>
                            <img src={Html} alt='HTML 5' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Css} alt='CSS3' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Angular} alt='Angular' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={ReactJs} alt='React' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Bootstrap}  alt='Bootstrap' className='technologies_imgspacing' />
                        </Row>
                    </Container>
                </Col>

                <Col>
                    <Container>

                        <p className='technologies_headingfontios aboutus_textalign' >Database</p>
                        <br />
                        <Row className='border'>
                            <img src={Mysql} alt='Mysql' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Mongo} alt='MongoDB' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Firebase} alt='Firebase' className='technologies_imgspacing' />
                        </Row>
                    </Container>
                </Col>

                <Col>
                    <p className='technologies_headingfontserv aboutus_textalign' >Server Tech</p>
                    <br />
                    <Container>
                        <Row className='border'>
                            <img src={Php} alt='PHP' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Node} alt='NodeJS' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Java} alt='JAVA' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Spring} alt='Spring Boot' className='technologies_imgspacing' />
                        </Row>
                    </Container>
                </Col>

                <Col>
                  <p className='technologies_headingfontios aboutus_textalign' >iOS and Android</p>
                  <br />
                    <Container>

                    <Row className='border'>
                        <img src={Xcode} alt="Xcode" className='technologies_imgspacing' />
                    </Row>
                    <Row className='border'>
                        <img src={Android} alt='Android Studio' className='technologies_imgspacing' />
                    </Row>

                        <br />

                          <p className='technologies_headingfontserv aboutus_textalign aboutus_textalign' >Framework</p>
                          <Row className='border'>
                              <img src={Flutter} alt='Flutter' className='technologies_imgspacing' />
                          </Row>
                          <Row className='border'>
                              <img src={Ionic} alt='Ionic Framework' className='technologies_imgspacing' />
                          </Row>

                    </Container>
                </Col>

                <Col>
                    <p className='technologies_headingfontserv aboutus_textalign' >Cloud</p>
                    <br />
                    <Container>
                        <Row className='border'>
                            <img src={Aws} alt="AWS" className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Firebase} alt='Firebase' className='technologies_imgspacing' />
                        </Row>
                    </Container>
                </Col>

                <Col>
                    <p className='technologies_headingfontserv aboutus_textalign' >Design</p>
                    <br />
                    <Container>
                        <Row className='border'>
                            <img src={Photoshop} alt='Adobe Photoshop' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Figma} alt='FIgma' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Corel} alt='Corel Draw' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Illustrator} alt='Adobe Illustrator' className='technologies_imgspacing' />
                        </Row>
                        <Row className='border'>
                            <img src={Premiere} alt='Adobe Premiere Pro' className='technologies_imgspacing' />
                        </Row>
                    </Container>
                </Col>
            </Row>
        </div>
        <br/>
        <br/>
        <br/>
        <Footer/>
    </div>
    )
}

export default Technologies
